<ion-card *ngIf="element" [class.element-v2]="isV2()">
	<ion-card-content>
		<ng-content></ng-content>
	</ion-card-content>
	<ion-footer>
		<app-documentation [documentation]="element.documentation" [v2]="isV2()"></app-documentation>
	</ion-footer>
</ion-card>
